












































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateProofOfAddressPocketSuccessViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-pocket-success-view-model';

@Component({ name: 'UpdateProofOfAddressPocketSuccess' })
export default class UpdateProofOfAddressPocketSuccess extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_proof_pocket_success_view_model = Vue.observable(
    new UpdateProofOfAddressPocketSuccessViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
